import File from './file';
import Player from './player';
import Force from './force';
import UpgradeAvailabilityChange from './upgradeavailabilitychange';
import TechAvailabilityChange from './techavailabilitychange';
import RandomUnitTable from './randomunittable';
import RandomUnit from './randomunit';
import RandomItemTable from './randomitemtable';
import RandomItemSet from './randomitemset';
import RandomItem from './randomitem';

export default {
  File,
  Player,
  Force,
  UpgradeAvailabilityChange,
  TechAvailabilityChange,
  RandomUnitTable,
  RandomUnit,
  RandomItemTable,
  RandomItemSet,
  RandomItem,
};
